"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Eventer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
class Eventer {
  constructor(emitLastValue = true) {
    (0, _defineProperty2.default)(this, "holder", {
      listenersMap: {},
      anyListeners: [],
      lastValues: {}
    });
    this.emitLastValue = emitLastValue;
  }
  on(event, listener) {
    if (!this.holder.listenersMap[event]) {
      this.holder.listenersMap[event] = [];
    } else if (this.holder.listenersMap[event].includes(listener)) {
      return;
    }
    if (this.emitLastValue && this.holder.lastValues[event] !== undefined) {
      listener(this.holder.lastValues[event]);
    }
    this.holder.listenersMap[event].push(listener);
  }
  off(event, listener) {
    if (this.holder.listenersMap[event]) {
      let index = this.holder.listenersMap[event].indexOf(listener);
      if (index > -1) {
        this.holder.listenersMap[event].splice(index, 1);
      }
    }
  }
  onAny(listener) {
    if (this.holder.anyListeners.includes(listener)) {
      return;
    }
    this.holder.anyListeners.push(listener);
  }
  offAny(listener) {
    let index = this.holder.anyListeners.indexOf(listener);
    if (index > -1) {
      this.holder.anyListeners.splice(index, 1);
    }
  }
  emit(event, data) {
    let collected = [];
    if (this.holder.listenersMap[event]) {
      for (let it of this.holder.listenersMap[event]) {
        try {
          let res = it(data);
          collected.push(res);
        } catch (err) {
          console.warn("Error emitting event", err, event, data);
        }
      }
    }
    for (let it of this.holder.anyListeners) {
      try {
        it(data);
      } catch (err) {
        console.warn("Error emitting event", err, event, data);
      }
    }
    if (this.emitLastValue) {
      this.holder.lastValues[event] = data;
    }
    return collected;
  }
  getLastValue(event) {
    return this.holder.lastValues[event];
  }
  clearListeners() {
    this.holder.listenersMap = {};
    this.holder.lastValues = {};
    this.holder.anyListeners = [];
  }
  migrateFrom() {
    return {
      ...this.holder.listenersMap
    };
  }
  migrateTo(listeners) {
    for (let [key, val] of Object.entries(listeners)) {
      if (!this.holder.listenersMap[key]) {
        this.holder.listenersMap[key] = val;
      } else {
        this.holder.listenersMap[key] = (0, _remeda.uniq)(this.holder.listenersMap[key].concat(val));
      }
    }
  }
  listenerCount(event) {
    if (event) {
      var _this$holder$listener;
      return ((_this$holder$listener = this.holder.listenersMap[event]) === null || _this$holder$listener === void 0 ? void 0 : _this$holder$listener.length) || 0;
    }
    return this.holder.anyListeners.length + Object.values(this.holder.listenersMap).reduce((acc, it) => acc + it.length, 0);
  }
}
exports.Eventer = Eventer;
//# sourceMappingURL=index.js.map